import React, { useCallback, useContext, useState } from "react";
import { ParagraphText, UBAppModal } from "../../../Libraries";
import EditCustomer from "../EditCustomer";
import { LanguageContext } from "../../../context/LanguageContext";
import { sentenceCase } from "../../../constants";
import ModalStyles from "../../../Libraries/UBAppModal/styles.module.css";

const AddCustomerModal = ({
  isOpen,
  handleClose,
  navigate,
  initialName,
  initialPhone,
  onSaveCallback,
  type = "in",
  title = "",
  isTypeField = true,
  className,
  backdropClassName,
  handleLogEventCustomerCreated = () => {},
  handleLogEventCustomerUpdate = () => {},
  isOnlyPhoneList,
  customerToUpdate = null,
  onRemoteSave,
  remoteCustomerId,
}) => {
  const [I18n] = useContext(LanguageContext);
  const formId = "add_customer_modal_form";
  const [formState, setFormState] = useState({
    loading: false,
    disabled: true,
  });
  const handleFormStateChange = useCallback((nextState) => {
    setFormState(nextState);
  }, []);

  const isUpdateMode = Boolean(customerToUpdate);
  const contactLabel = isTypeField
    ? sentenceCase(I18n.contact).toLowerCase()
    : title || sentenceCase(I18n.contact).toLowerCase();
  const modalTitle = isUpdateMode ? "phone number" : contactLabel;
  const modalHeading = isUpdateMode ? "Update " : "Add new ";

  return (
    <UBAppModal
      id="add_customer_modal"
      open={isOpen}
      handleClose={handleClose}
      className={`${ModalStyles.addCustomerModal} ${className ?? ""}`}
      backdropClassName={backdropClassName}
      header={{
        title: (
          <ParagraphText className="d-flex align-items-center fontSize20 fontWeight500 newFontColor">
            {modalHeading}{modalTitle}
          </ParagraphText>
        ),
        handleClose: handleClose,
        dont_show_cross_icon: true,
      }}
      footer={[
        {
          data: {
            className:
              "buttonTeritary fontSize14 fontWeight400 textUppercase cursorPointer",
            title: I18n.cancel,
            onClick: handleClose,
            id: "add_customer_cancel",
          },
        },
        {
          data: {
            className: "ubPrimaryButton",
            title: I18n.save,
            type: "submit",
            form: formId,
            loading: formState.loading,
            disabled: formState.disabled,
            id: "add_customer_save",
          },
        },
      ]}
    >
      <EditCustomer
        customer={customerToUpdate}
        closeCallback={handleClose}
        navigate={navigate}
        isAddFlow={!isUpdateMode}
        initialName={initialName}
        initialPhone={initialPhone}
        onSaveCallback={onSaveCallback}
        type={type}
        title={title}
        isTypeField={isUpdateMode ? false : isTypeField}
        handleLogEventCustomerCreated={handleLogEventCustomerCreated}
        handleLogEventCustomerUpdate={handleLogEventCustomerUpdate}
        isOnlyPhoneList={isUpdateMode || Boolean(isOnlyPhoneList)}
        formId={formId}
        onFormStateChange={handleFormStateChange}
        onRemoteSave={onRemoteSave}
        remoteCustomerId={remoteCustomerId}
      />
    </UBAppModal>
  );
};

export default AddCustomerModal;
